module.exports = __webpack_public_path__ + "assets/img/page1-design-base-edb8b264.jpg";